import * as t from './types';
import * as r from './registry';
import './server';

export function startTask(
  action: t.WorkerAction,
  serializedParameters: string,
  progressListener: t.TaskProgressListener,
): t.TaskCreationResponse {
  const worker = getNewWorker();
  // We don't want messages to be lost by arriving before the tasks map
  // knows about the task.
  // We guarantee this by not asking it for anything until after
  // we have registered it.
  const uuid = r.setTask(worker);

  const resultPromise = new Promise<string>((resolve, reject) => {
    // Listen for messages coming back from the worker.
    worker.addEventListener('message', ev => {
      const data = ev.data;
      const message = (
        typeof data === 'string'
          ? JSON.parse(data)
          : data
      ) as t.TaskResponseMessage;

      switch (message.status) {
        case t.TaskStatus.Progressing:
          progressListener(message.progress);
          break;
        case t.TaskStatus.Complete:
          r.cancelTask(uuid);
          resolve(message.serializedResult);
          break;
        case t.TaskStatus.Failed:
          r.cancelTask(uuid);
          reject(message.excuse);
          break;
        default:
          console.error('Unknown TaskStatus received from worker task.')
      };
    });
  });

  const creationRequest: t.TaskCreationRequest = {
    uuid,
    action: action.toString(),
    serializedParameters,
  };

  worker.postMessage(JSON.stringify(creationRequest));

  return {
    resultPromise,
    cancelTask: () => r.cancelTask(uuid),
  };
}


///////////////////////////////////////////////////////////////////////////////
// Implementation Functions
///////////////////////////////////////////////////////////////////////////////

function getNewWorker(): Worker {
  const worker = new Worker(
    new URL(
      'server.ts',
      import.meta.url,
    ),
    {type: 'module'},
  );

  return worker;
}

